import { styled, Card as MuiCard } from '@mui/material';

const Card = styled(MuiCard)(() => ({
  cursor: 'pointer',
  boxShadow: ' 0px 0px 0px 1px #E0E0E0',
  ':hover': {
    backgroundColor: '#1976D214',
    boxShadow: ' 0px 0px 0px 1px #1976D2',
  },
}));

export { Card };
